class HeaderCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.parent = this.closest('.product-countdown');
      this.headerCountdownBar = this.closest('.header-countdown-bar');
      this.date = this.parseToDate(this.dataset.date).getTime();
      
      if (isNaN(this.date)) {
        this.unload();
        return;
      }

      // Check if date is already in the past
      if (this.date < Date.now()) {
        this.unload();
        return;
      }

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 200
      });
    }

    parseToDate(input) {
      if (input.includes("T")) {
        return new Date(input);
      }
      
      const parts = input.split('-');
      let targetDate;
      
      // Handle both DD-MM-YYYY and MM-DD-YYYY formats
      if (parts.length === 3) {
        const [part1, part2, year] = parts;
        
        // Check if it's DD-MM-YYYY format (day > 12 indicates DD-MM format)
        if (parseInt(part1) > 12) {
          // DD-MM-YYYY format
          const day = part1;
          const month = part2;
          targetDate = new Date(`${year}-${month}-${day}`);
        } else if (parseInt(part2) > 12) {
          // MM-DD-YYYY format
          const month = part1;
          const day = part2;
          targetDate = new Date(`${year}-${month}-${day}`);
        } else {
          // Ambiguous case, assume DD-MM-YYYY based on your input
          const day = part1;
          const month = part2;
          targetDate = new Date(`${year}-${month}-${day}`);
        }
      } else {
        // Fallback to original parsing
        const [month, day, year] = parts;
        targetDate = new Date(`${year}-${month}-${day}`);
      }
      
      // Set time to end of day (23:59:59) to ensure countdown shows for the entire target date
      targetDate.setHours(23, 59, 59, 999);
      return targetDate;
    }

    init() {
      this.timer();
      this.dataset.interval = setInterval(this.timer.bind(this), 1000);
    }

    timer() {
      const now = new Date(),
        countTo = new Date(this.date),
        timeDifference = (countTo - now);

      if (timeDifference < 0) {
        this.unload();
        return;
      }

      const secondsInADay = 60 * 60 * 1000 * 24,
        secondsInAHour = 60 * 60 * 1000;

      const days = Math.floor(timeDifference / (secondsInADay) * 1);
      const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
      const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
      const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);

      if (this.dataset.compact == 'true') {
        const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}${theme.dateStrings.d}</span></div>` : '';
        const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : '0' + hours}:${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}</span></div>`;
    
        this.innerHTML = dayHTML + otherHTML;
      }
      else {
        const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? theme.dateStrings.day : theme.dateStrings.days}</div>` : '';
        const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? theme.dateStrings.hour : theme.dateStrings.hours}</div>`;
        const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? theme.dateStrings.minute : theme.dateStrings.minutes}</div>`;
        const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? theme.dateStrings.second : theme.dateStrings.seconds}</div>`;
        const colon = `<span class="colon">:</span>`;
        const dayColon = days > 0 ? colon : '';

        this.innerHTML = dayHTML + dayColon + hourHTML + colon + minHTML + colon + secHTML;
      }
    }

    unload() {
      if (this.dataset.interval) {
        clearInterval(this.dataset.interval);
      }

      this.classList.add('hidden');
      
      // Hide the parent product countdown if it exists
      if (this.parent) {
        this.parent.classList.add('hidden');
      }
      
      // Hide the entire header countdown bar if it exists
      if (this.headerCountdownBar) {
        this.headerCountdownBar.style.display = 'none';
      }
    }
  }
  customElements.define('header-countdown-timer', HeaderCountdownTimer);